"use client";
import { useLocale } from "next-intl";
import Image from "next/image";

export default function CopyRights() {
  const locale = useLocale();

  return (
    <div className="mt-10 flex flex-col md:flex-row justify-between items-center gap-6 select-none">
      <div className="flex flex-col gap-2 items-center md:items-start">
        <p className="text-sm font-medium text-slate-400">
          © {new Date().getFullYear()}{" "}
          <span className="text-white font-bold">SNA Alaqaria.</span>{" "}
          {locale === "en" ? "All Rights Reserved" : "جميع الحقوق محفوظة"}
        </p>
        <p className="text-[10px] text-slate-500 uppercase tracking-widest">
          {locale === "en" ? "Crafted with Excellence" : "صُنع بتميز وإتقان"}
        </p>
      </div>

      <div className="relative group">
        <div className="absolute -inset-1 bg-linear-to-r from-emerald-500/20 to-blue-500/20 rounded-lg blur opacity-25 group-hover:opacity-50 transition duration-1000"></div>
        <div className="relative bg-slate-900/50 backdrop-blur-sm border border-white/5 rounded-lg px-4 py-2">
          <Image
            src="/Payment.png"
            alt="Payment Methods"
            width={220}
            height={40}
            className="opacity-80 hover:opacity-100 transition-opacity"
          />
        </div>
      </div>
    </div>
  );
}
